export const EQ_FREQUENCIES = [
  20, 25, 31.5, 40, 50, 63, 80, 100, 125, 160, 200, 250, 315, 400, 500, 630,
  800, 1000, 1250, 1600, 2000, 2500, 3150, 4000, 5000, 6300, 8000, 10000, 12500,
  16000, 20000,
];

export const PUBLIC_MIN_FREQUENCY = 500;
export const PUBLIC_MAX_FREQUENCY = 8000;

export function isFrequencyWithinRange(frequency, min, max) {
  return frequency >= min && frequency <= max;
}

export function filterFrequenciesByRange(frequencies, min, max) {
  return frequencies.filter((frequency) => isFrequencyWithinRange(frequency, min, max));
}


